import CompanyService from '@/bundles/Companies/services/CompanyService';
import CompanyServiceV2 from '@/bundles/Companies/services/CompanyServiceV2';
import { httpV1, httpV2 } from '@/bundles/Http/factory/httpFactory';
import ErrorMapper from '@/bundles/Http/mappers/ErrorMapper';
import CompanyToMapper from '@/bundles/Companies/mappers/CompanyToMapper';
import { RecordMapper } from '@/bundles/App/models/RecordMapper';

function companyServiceFactory () {
  return new CompanyService({
    transport: httpV1,
    errorMapper: new ErrorMapper(),
    companyMapper: new CompanyToMapper(),
  });
}

function companyServiceV2Factory () {
  return new CompanyServiceV2(
    httpV2,
    new ErrorMapper(),
  );
}

export const companyService = companyServiceFactory();
export const companyServiceV2 = companyServiceV2Factory();
